export const RuleActionTypes = {
  COUNTRY: 'country',
  CONTINENT: 'continent',
  URL: 'url',
  SOURCE_IP_ADDRESS: 'source_ip_address',
};
